import { api } from '../lib/api-client';
import { fail, fromApiResult, type DataResult } from '../lib/data-result';
import type { CreateIssueRequest, IssueDetail } from '../types/api';

export async function createIssue(request: CreateIssueRequest): Promise<DataResult<IssueDetail>> {
  try {
    return fromApiResult(await api.issues.create(request), 'Submission failed');
  } catch (_e) {
    return fail('Network error');
  }
}

if (typeof window !== 'undefined') {
  window.HomePageData = {
    createIssue,
  };
}
